import React, { forwardRef } from 'react';
import { css } from '@emotion/css';
import Scrollbars, { ScrollbarProps } from 'react-custom-scrollbars';

interface CustomScrollbarProps extends ScrollbarProps {
    hideHorizontalScrollbar?: boolean;
}

const CustomScrollbars = forwardRef<Scrollbars, CustomScrollbarProps>((props, ref) => {
    const { hideHorizontalScrollbar, ...scrollbarProps } = props;

    return (
        <Scrollbars
            {...scrollbarProps}
            ref={ref}
            style={props.style}
            autoHide={false}
            className={`${scrollBarStyle} ${props.autoHide === true ? "auto-hide" : ""} ${hideHorizontalScrollbar ? "hide-horizontal" : ""} ${props.className ?? ''} scrollbars-class`}
            renderTrackHorizontal={hideHorizontalScrollbar ? () => <div style={{ display: 'none' }} /> : scrollbarProps.renderTrackHorizontal}
        >
            {props.children}
        </Scrollbars>
    );
});

const scrollBarStyle = css`   
    &.auto-hide > div:last-child {
        opacity: 0;
        transition: opacity 200ms ease;
    }                
    &.auto-hide:hover > div:last-child {
        opacity: 1;
    }
    &.hide-horizontal {
        overflow-x: hidden;
    }
    &.hide-horizontal > div:first-child {
        overflow-x: hidden;
    }
`;

export default CustomScrollbars;